import { Hero } from "../components/Hero";
import { PainPoints } from "../components/PainPoints";
import { Services } from "../components/Services";
import { PrismaMethod } from "../components/PrismaMethod";
import { Blog } from "../components/Blog";
import { Podcast } from "../components/Podcast";
import { NewsletterForm } from "../components/NewsletterForm";
import { Contact } from "../components/Contact";
import { Seo } from "../components/Seo";

export function Home() {
  return (
    <>
      <Seo
        title="P2A Marketing & Branding | Consultoria Estratégica"
        description="A P2A Marketing e Branding é uma consultoria estratégica e operação especializada em marketing, branding e automações com I.A. para infoprodutos e negócios físicos."
        path="/"
      />
      <main>
        <Hero />
        <PainPoints />
        <Services />
        <PrismaMethod />
        <Blog />
        <Podcast />
        <NewsletterForm />
        <Contact />
      </main>
    </>
  );
}
